
import { round_to_01, round_to_10 } from "../../functions.ts";
import { useStore } from "../../state/state.ts";
import Statistics from "../statistics.tsx";
export default function StatisticsEnergieverbrauch() {
  const annual_energy_consumption_kwh_adjusted = useStore((state)=>state.annual_energy_consumption_kwh_adjusted || 0);
  const annual_energy_consumption_kwh_planned = useStore((state)=>state.annual_energy_consumption_kwh_planned || 0);
  const heizung = useStore((state)=>state.heizung);
  const verbrauchseinheit_oel = useStore((state)=>state.verbrauchseinheit_oel);
  const verbrauchseinheit_gas = useStore((state)=>state.verbrauchseinheit_gas);
  const verbrauchseinheit_holz = useStore((state)=>state.verbrauchseinheit_holz);
  const verbrauchseinheit_andere = useStore((state)=>state.verbrauchseinheit_andere);

  let energy_consumption_now = 0;
  let energy_consumption_future = 0;
  let unit = "kWh/Jahr";

    switch (heizung) {
      case "heating_system_current_0":
      case "heating_system_current_8":
      case "heating_system_current_10":
        // oelverbrauch
        //if (verbrauchseinheit_oel == "liter"){
          energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted * 0.1);
          energy_consumption_future=round_to_10(annual_energy_consumption_kwh_planned * 0.1);
          unit="l/Jahr";
        //}
        break;
      case "heating_system_current_1":
      case "heating_system_current_7":
      case "heating_system_current_9":
        // gasverbrauch
        if (verbrauchseinheit_gas == "m3"){
          energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted * 0.0952);
          energy_consumption_future=round_to_10(annual_energy_consumption_kwh_planned * 0.0952); 
          unit="m³/Jahr";
        }else{
          energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted);
          energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned); 
          unit="kwh/Jahr";
        }
        break;
      case "heating_system_current_2":
        // holzverbrauch
        if (verbrauchseinheit_holz == "kg"){
          energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted / 4.8);
          energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned / 4.8); 
          unit="kg/Jahr";
        }else if ((verbrauchseinheit_holz == "t")) {
          energy_consumption_now = round_to_01(annual_energy_consumption_kwh_adjusted / 4800);
          energy_consumption_future = round_to_01(annual_energy_consumption_kwh_planned / 4800); 
          unit="t/Jahr";
        }else if ((verbrauchseinheit_holz == "m3")) {
          energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted / 3.120);
          energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned / 3.120); 
          unit="m³/Jahr";
        }
        break;
      case "heating_system_current_3":
      case "heating_system_current_4":
      default:
          // stromverbrauchwaermepumpe
          energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted);
          energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned); 
          unit="kwh/Jahr";
          break;
    }

    return <Statistics label="Energieverbrauch" now={energy_consumption_now} future={energy_consumption_future} unit={unit} />

}